export default {
  default: () => import("/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/layouts/default.vue"),
  edgeless: () => import("/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/layouts/edgeless.vue")
}